import { Component } from '@verndale/core';


class Module extends Component {
  setupDefaults() {
    this.dom = {
      $lenghSelect: this.el.querySelector('.select-box-options-trigger'),
      $lengthFrom: this.el.querySelector('#SearchBarQuickLengthFrom'),
      $lengthTo: this.el.querySelector('#SearchBarQuickLengthTo'),
    };

    // this.setLenghtValue();
  }

  addListeners() {
    // this.dom.$lenghSelect.addEventListener('click', this.toggleSelectBtnOptions.bind(this));
    // this.dom.$lengthFrom.addEventListener('change', this.handleLenghtFromChange.bind(this));
    // this.dom.$lengthTo.addEventListener('change', this.handleLenghtToChange.bind(this));
    // document.addEventListener('click', this.closeLenghtDropDown.bind(this));
  }

  toggleSelectBtnOptions(e) {
    e.currentTarget.closest('.select-box').classList.toggle('active');
  }

  handleLenghtFromChange(e) {
    const val = Number(e.currentTarget.value);
    this.dom.$lengthTo.querySelectorAll('option').forEach((option) => {
      const optValue = Number(option.getAttribute('value'));
      if (optValue < val) {
        option.setAttribute('hidden', true);
      } else {
        option.removeAttribute('hidden');
      }
    });
    this.setLenghtValue();
  }

  handleLenghtToChange(e) {
    const val = Number(e.currentTarget.value);
    e.currentTarget.closest('.select-box').classList.remove('active');
    this.dom.$lengthFrom.querySelectorAll('option').forEach((option) => {
      const optValue = Number(option.getAttribute('value'));
      if (optValue > val) {
        option.setAttribute('hidden', true);
      } else {
        option.removeAttribute('hidden');
      }
    });
    this.setLenghtValue();
  }

  setLenghtValue() {
    const fromVal = this.dom.$lengthFrom.value;
    const toVal = this.dom.$lengthTo.value;

    if (fromVal === '' && toVal === '') {
      this.dom.$lenghSelect.innerHTML = this.dom.$lenghSelect.getAttribute('data-default');
    } else {
      this.dom.$lenghSelect.innerHTML = `${fromVal}${fromVal !== '' ? '\'' : ''} ${fromVal !== '' && toVal !== '' ? '-' : ''} ${toVal}${toVal !== '' ? '\'' : ''}`;
    }
  }

  closeLenghtDropDown(e) {
    if (e.target.closest('[rel=hbs-length]') === null) {
      this.dom.$lenghSelect.closest('.select-box').classList.remove('active');
    }
  }
}


export default Module;